import { z } from "zod";

// Payload for PUT /admin/settings/{scope}/{key} — replace a setting's value. is_secret is preserved from the
// stored row (value-only update); a plain setting becomes secret only via the body-less
// POST /admin/settings/{scope}/{key}/convert-to-secret, and secret → plain is deliberately impossible.
// scope + key come from the route, not the body. Kept JSON-Schema-representable so it round-trips
// Zod → JSON Schema → C#.
export const updateSettingsRequestSchema = z.object({
  value: z.string().min(1),
});
